import styled from "styled-components"
import { Avatar } from "./Avatar";

import Play from "src/assets/icons/play.svg";
import Shuffle from "src/assets/icons/shuffle.svg";
import Repeat from "src/assets/icons/repeat.svg";
import Volume from "src/assets/icons/volume.svg";
import { theme } from "../styles/theme";

import { FaList, FaPause } from "react-icons/fa6";
import { useEffect, useState } from "react";
import { formatTime } from "../shared/utils/helper";
import { BsFillVolumeMuteFill } from "react-icons/bs";

const Container = styled.div`
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: space-between;

`;

const Controllers = styled.div`
    width: 468px;
    display: flex;
    flex-direction: row;
    gap: 8px; 
    justify-content: flext-start;
    align-items: center;
`;

const Control = styled.button`
    width: 48px; 
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`

const Question = styled.div`
    width: 118px;
    font-family: ${theme.fonts.secondary};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.base};
    line-height: 135%;
    letter-spacing: 0%;
    color: ${theme.colors.black};

`;
const Duration = styled.div`
    min-width: 94px;
    font-family: ${theme.fonts.secondary};
    font-weight: ${theme.fontWeights.regular};
    font-size: ${theme.fontSizes.base};
    line-height: 135%;
    letter-spacing: 0%;
    color: ${theme.colors.black};
`;


const Queue = styled.button`
    width: 103px;
    height: 38px;
    border-radius: 40px;
    padding: 8px 16px;

    display: flex;
    align-items: center;
    gap: 6px;
    background: #190F491A;


    &>span{
        font-family: ${theme.fonts.primary};
        font-weight: ${theme.fontWeights.bold};
        font-size: ${theme.fontSizes.base};
        line-height: 135%;
        letter-spacing: 0%;
        color: ${theme.colors.secondary};
    }
`;

interface PlayerControlProps{
    playing: boolean;
    duration: number;
    totalDuration: number;
    totalPlayed?: number;
    totalVideos: number;
    currentVideo: number;
    hideShuffle?: boolean;
    hideRepeat?: boolean;
    hideMute?: boolean;
    hideDuration?: boolean;
    hideTagging?: boolean;
    hideQueueBtn?: boolean;
    onPlay: (status: boolean)=>void;
    onRepeat: (status: boolean)=>void;
    onMute: (status: boolean)=>void;
    onShuffle: (status: boolean)=>void;
}

const PlayerControl: React.FC<PlayerControlProps>=({
    playing,
    duration, 
    totalDuration, 
    totalPlayed, 
    currentVideo, 
    totalVideos, 
    onPlay, 
    onRepeat, 
    onMute, 
    onShuffle,
    hideShuffle=false,
    hideRepeat=false,
    hideMute=false,
    hideDuration=false,
    hideTagging=false,
    hideQueueBtn=false
})=>{
    const [pyaing, setPlaying] = useState<boolean>(false);
    const [repeat, setRepeat] = useState<boolean>(false);
    const [shuffle, setShuffle] = useState<boolean>(false);
    const [volumn, setVolume] = useState<number>(1);
    const [isMuted, setIsMuted] = useState(false);

    const [progress, setProgress] = useState<number>(1);

    const handlePlay = ()=>{
        setPlaying(prev=>!prev);
        onPlay(!pyaing);
    }
    
    const handleRepeat=()=>{
        setRepeat(prev=>!prev);
        onRepeat(!repeat);
    }
    const handleShuffle=()=>{
        setShuffle(prev=>!prev);
        onShuffle(!shuffle);
    }

    const handleMute=()=>{
        setIsMuted(prev=>!prev);
        onMute(!isMuted);
    }


    useEffect(()=>{
        setProgress(duration)
    }, [duration]);

    useEffect(()=>{
        setPlaying(playing);
    }, [playing])
    return(
        <Container>
            <Controllers>
                <Control onClick={handlePlay}>{pyaing ? <FaPause size={23} /> : <img src={Play} />}</Control>
                {!hideShuffle && <Control onClick={handleShuffle}><img src={Shuffle} /></Control>}
                {!hideRepeat && <Control onClick={handleRepeat}><img src={Repeat} /></Control>}
                {!hideMute && <Control onClick={handleMute}>
                    {!isMuted ? <img src={Volume} /> : <BsFillVolumeMuteFill size={30} />}
                </Control>}

                {!hideTagging && <Question>Question {currentVideo + 1} / {totalVideos}</Question>}
                {!hideDuration && <Duration>{formatTime(totalPlayed + progress)} / {totalDuration? formatTime(totalDuration): '00:00'}</Duration>}
            </Controllers>
            {!hideQueueBtn &&
                <Queue>
                    <FaList color={theme.colors.secondary} size={16} />
                    <span>Queue</span>
                </Queue>
            }
        </Container>
    )
}

export default PlayerControl;